import { Controller } from "@hotwired/stimulus";

export class NoEmailController extends Controller {
  static targets = ["checkbox", "emailField"];

  connect() {
    this.toggle();
  }

  toggle() {
    const noEmail = this.checkboxTarget.checked;

    if (noEmail) {
      this.emailFieldTarget.value = "";
      this.emailFieldTarget.disabled = true;
      this.emailFieldTarget.removeAttribute("required");
    } else {
      this.emailFieldTarget.disabled = false;
      this.emailFieldTarget.setAttribute("required", "required");
    }

    // Disable send_email notification checkbox when no email
    const sendEmail = document.getElementById("send_email");
    if (sendEmail) {
      sendEmail.disabled = noEmail;
      if (noEmail) sendEmail.checked = false;
    }
  }
}
